import { createContext, useContext, useRef, useState, useEffect } from "react";

const PlayerContext = createContext(null);

export function PlayerProvider({ children }) {
  const audioRef = useRef(null);
  const [current, setCurrent] = useState(null); // track object
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    if (!audioRef.current) {
      audioRef.current = new Audio();
    }
    const audio = audioRef.current;
    const onEnded = () => setIsPlaying(false);
    audio.addEventListener("ended", onEnded);
    return () => audio.removeEventListener("ended", onEnded);
  }, []);

  const play = (track) => {
    const audio = audioRef.current;
    if (!track.audio_preview) return;
    if (current && current.id === track.id) {
      // toggle
      if (isPlaying) {
        audio.pause();
        setIsPlaying(false);
      } else {
        audio.play();
        setIsPlaying(true);
      }
      return;
    }
    audio.src = track.audio_preview;
    audio.play();
    setCurrent(track);
    setIsPlaying(true);
  };

  const toggle = () => {
    const audio = audioRef.current;
    if (!current) return;
    if (isPlaying) {
      audio.pause();
      setIsPlaying(false);
    } else {
      audio.play();
      setIsPlaying(true);
    }
  };

  const stop = () => {
    const audio = audioRef.current;
    audio.pause();
    setIsPlaying(false);
    setCurrent(null);
  };

  return (
    <PlayerContext.Provider value={{ current, isPlaying, play, toggle, stop }}>
      {children}
    </PlayerContext.Provider>
  );
}

export const usePlayer = () => useContext(PlayerContext);
